module.exports = __webpack_public_path__ + "img/GRC.ffd46b3b.svg";